// extracted by mini-css-extract-plugin
export default {"settingWrapper":"settingWrapper___zesBR","outletWrapper":"outletWrapper___Zl2jj","itemDescription":"itemDescription___WJ1sc"};